import { render } from "./registered.widget.wp.vue?vue&type=template&id=5374ecfa"
import script from "./registered.widget.wp.vue?vue&type=script&lang=js"
export * from "./registered.widget.wp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__